// ───────────────────────────────────────────────
// Placeholder social-login buttons. Disabled on purpose — OAuth (Google /
// Apple) is deferred to a post-M2 follow-up, but the buttons ship now so the
// login/signup layout is final and won't shift when OAuth lands.
// ───────────────────────────────────────────────
const PROVIDERS = [
  { id: "google", label: "Continue with Google" },
  { id: "apple", label: "Continue with Apple" },
];

export function OAuthButtons() {
  return (
    <div className="auth-oauth">
      {PROVIDERS.map((p) => (
        <button
          key={p.id}
          type="button"
          className="btn auth-oauth-btn"
          disabled
          title="Coming soon"
        >
          {p.label}
        </button>
      ))}
      <div className="auth-divider">
        <span>or</span>
      </div>
    </div>
  );
}
